// extracted by mini-css-extract-plugin
module.exports = {"link":"NounderBRNounBRContent_link__1U_AT","bidRow":"NounderBRNounBRContent_bidRow__1tZJY","currentBidCol":"NounderBRNounBRContent_currentBidCol__m39uc"};